(() => {
  const body = document.body;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  if (menuButton && mobilePanel) {
    menuButton.addEventListener('click', () => {
      const open = mobilePanel.classList.toggle('is-open');
      body.classList.toggle('menu-open', open);
      menuButton.setAttribute('aria-expanded', String(open));
    });
    mobilePanel.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      mobilePanel.classList.remove('is-open');
      body.classList.remove('menu-open');
      menuButton.setAttribute('aria-expanded', 'false');
    }));
  }

  const chatButtons = document.querySelectorAll('[data-contact-toggle]');
  const chat = document.querySelector('[data-contact-popover]');
  const chatClose = document.querySelector('[data-contact-close]');
  const toggleChat = () => chat && chat.classList.toggle('is-open');
  chatButtons.forEach(btn => btn.addEventListener('click', toggleChat));
  if (chatClose) chatClose.addEventListener('click', () => chat.classList.remove('is-open'));

  const reveal = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveal.forEach(el => observer.observe(el));
  } else {
    reveal.forEach(el => el.classList.add('is-visible'));
  }
})();
